import React, { FC } from 'react';

import { Box } from '@rbilabs/components-library';

import { designTokens } from 'styles/constants/design-tokens';

import { FIXED_STICKY_FOOTER_HEIGHT } from './constants';
import { StickyBoxChild } from './sticky-footer.styled';
import { IStickyFooter } from './types';

/**
 * StickyFooter is a fixed bottom banner component.
 * IT takes a set of element(s) and renders them using flex.
 * It will do this depending on the number of spaces specified for the element.
 * Else, it'll default to take up the whole width (i.e. 'flex: 1').
 *
 * It can also take in additional Box props if any style needs overriding.
 * This makes the component more flexible for various use cases.
 */
export const StickyFooter: FC<IStickyFooter> = ({
  boxProps,
  elements,
  padding = '1rem 1rem max(1rem, env(safe-area-inset-bottom))',
}) => (
  <Box
    data-testid="sticky-footer-banner"
    position="fixed"
    bottom="0"
    left="0"
    right="0"
    zIndex={`${Styles.zIndex.overlay + 300}`}
    width="100%"
    minHeight={`calc(env(safe-area-inset-bottom) + ${FIXED_STICKY_FOOTER_HEIGHT})`}
    padding={padding}
    boxShadow={designTokens['drop-shadow-bottom-nav']}
    background={designTokens['background-pattern']}
    {...boxProps}
  >
    {elements.map(({ element, spaces }, idx) => {
      // TODO: remove condition when all consumers move to TS
      if (!element) {
        return null;
      }
      return (
        <StickyBoxChild key={idx} lastChild={idx === elements.length - 1} spaces={spaces}>
          {element}
        </StickyBoxChild>
      );
    })}
  </Box>
);
